/** @jsx jsx */
import React from 'react'
import { jsx } from 'theme-ui'
import { css } from '@emotion/react'

import Buttons from '../../buttons'
import Card from '../../card'
import Paragraph from '../../paragraph'
import { ImageInline } from '../../image'

import { FlexCols, FlexCol, VStack } from '../../../styles/els'
import { resolveButtons, formatImage } from '../../../lib/helpers'

const Cards = (props) => {
  const { title, subtitle, cards, sectionColor, smallerText, ...otherProps } =
    props

  return cards && cards.length > 0 ? (
    <div>
      {(title || subtitle) && (
        <div
          sx={{
            pt: 6,
            pb: cards && cards.length > 0 ? 8 : null,
          }}
        >
          <Paragraph
            heading={title}
            subheading={subtitle}
            prefixSubheading={true}
            hTier={3}
            align="center"
          />
        </div>
      )}
      {cards && cards.length > 0 ? (
        <FlexCols
          sx={{
            alignItems: 'stretch',
          }}
          space={[4, 7]}
        >
          {cards.map((_card, _i) => {
            const { image: _image, title, subtitle, text, buttons } = _card
            const image = formatImage(_image)

            return (
              <FlexCol
                key={_i}
                base={[1, null, null, null, 2]}
                sx={{
                  display: 'flex',
                  flex: 1,
                  alignItems: 'stretch',
                }}
              >
                <Card inner={true} color={sectionColor}>
                  <VStack>
                    {image && (
                      <div sx={{ width: '100%' }}>
                        <div sx={{ mx: 'auto', maxWidth: '240px' }}>
                          <ImageInline image={image} />
                        </div>
                      </div>
                    )}
                    <Paragraph
                      heading={title}
                      subheading={subtitle}
                      hTier={3}
                      htmlText={text}
                      tTier={smallerText ? 2 : null}
                      buttons={resolveButtons(buttons)}
                      align="center"
                    />
                  </VStack>
                </Card>
              </FlexCol>
            )
          })}
        </FlexCols>
      ) : null}
    </div>
  ) : null
}

export default Cards
